import React from 'react';
import { ProfileResource } from '../types/quiz';

interface ResourcesDownloadProps {
  resources: ProfileResource[];
}

const ResourcesDownload: React.FC<ResourcesDownloadProps> = ({ resources }) => {
  // Don't render if no resources
  if (!resources || resources.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 md:p-10 mb-8">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6 md:mb-8">
        Your Free Resources
      </h2>

      <p className="text-base md:text-lg text-gray-700 text-center mb-6 md:mb-8">
        We've put together some tools specifically for families like yours:
      </p>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6">
        {resources.map((resource) => (
          <a
            key={resource.id}
            href={resource.download_url || '#'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              // Track resource download in Google Analytics (production only)
              if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
                if (typeof (window as any).gtag === 'function') {
                  (window as any).gtag('event', 'quiz_resource_downloaded', {
                    event_category: 'Quiz',
                    event_label: 'Resource Downloaded',
                    resource_title: resource.title
                  });
                  console.log('📊 GA Event: quiz_resource_downloaded -', resource.title);
                }
              }
            }}
            className="group block p-6 md:p-8 border-2 border-gray-200 rounded-lg hover:border-indigo-500 hover:shadow-md transition-all"
          >
            <div className="flex items-start gap-4">
              {/* PDF Icon */}
              <div className="flex-shrink-0 text-3xl md:text-4xl group-hover:scale-110 transition-transform">
                📄
              </div>

              <div className="flex-1">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">
                  {resource.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 mb-3">
                  {resource.description}
                </p>
                <div className="flex items-center gap-2 text-indigo-600 text-sm md:text-base font-semibold">
                  <span>Download PDF</span>
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ResourcesDownload;
